import { Navigate } from 'react-router-dom'
import { useAuthContext } from '@contexts/authContext'

const Protect = ({ children }) => {
  const { authenticated, state } = useAuthContext()
  return (authenticated || state.firstRender)
    ? children
    : <Navigate to='/landing' />
}

export default Protect
